import React from 'react'
import { ButtonGroup, Button, Panel } from 'rsuite'
import './custom-tab.scss'

export interface Tabs {
  id: number
  title: string
}
interface ICustomTab {
  tabs: Tabs[]
  activeTab: number
  handleTabChange: (val: number) => void
}

export const CustomTab = ({ tabs, activeTab, handleTabChange }: ICustomTab) => {
  return (
    <Panel className="tab-panel">
      <ButtonGroup>
        {tabs?.map((key) => (
          <Button
            key={key.id}
            active={key.id === activeTab}
            onClick={() => handleTabChange?.(key.id)}
          >
            {key.title}
          </Button>
        ))}
      </ButtonGroup>
    </Panel>
  )
}

export default CustomTab
